export default __webpack_public_path__ + "static/media/831.a4fff7f2.png";